import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CopyDirective } from '../../directives/copy.directive';
import { CommonService } from '../../services/common.service';
import { WebStorageService } from '../../services/web-storage.service';

@Component({
  selector: 'app-transak-modal',
  templateUrl: './transak-modal.component.html',
  styleUrls: ['./transak-modal.component.css']
})
export class TransakModalComponent implements OnInit{
  @Input() transakModal : boolean = true;
  @Output() closeModal = new EventEmitter();
  @Output() openModal = new EventEmitter();
  user: any;
  /**
   * constructor
   */
  constructor(
    private webStorageService: WebStorageService,
    public commonService: CommonService,
    private copyDirective: CopyDirective,
  ) { }

  ngOnInit() {
    this.user = this.webStorageService.getLocalStorage('user') != null ? JSON.parse(this.webStorageService.getLocalStorage('user') || 'undefined') : this.user;
  }

  /**
   * Redircts transack link
   */
  redirctTransackLink() {
        this.commonService.getTransackLink(this.user, (route: any) => {
            if (route) {
                window.open(route)
                this.closeTransakModal();
            }
        })
    }

 /**
  * Closes transak modal
  */
 closeTransakModal(){
   this.closeModal.emit();
    }

 /**
     * Copys content
     * @param content
     */
    public copy(content: string) {
        this.copyDirective.copy(content)
    }

}
